import './bootstrap/bootstrap'

// shido plugins
import dimentions from 'shido.dimentions.js/src/dimentions.js'
import forms from 'shido.forms.js/src/forms.js'
import proportional from 'shido.proportional.js/src/proportional.js'

// app
// require('../../../node_modules/...')
import alert from './components/alerts'
import Nav from './components/nav'
import DeferImages from "./components/defer-images";
import Anchor from "./components/anchor";

require('paroller.js')
require('@fancyapps/fancybox/dist/jquery.fancybox.js')

// Initializers
const docReady = () => {
  new dimentions().init()
  new alert().session()
  new forms().init()
  new proportional().init()

  Nav()
  DeferImages()
  Anchor()

  $("[data-paroller-factor]").paroller()
}

const winLoad = () => {
  // ...
}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener('DOMContentLoaded', () => {
  docReady()
  docReadyWinload()
}, false)
window.addEventListener('load', () => {
  winLoad()
  docReadyWinload()
}, false )
// ---
// ---
